module.exports = __webpack_public_path__ + "img/4.95bd33ff.jpg";